import Vue from 'vue';

import BaseLayout from '@/components/_core/ui/_base-layout/index.vue';
import { hasSafeaPermission } from '~/helpers/_core/safea-permissions';

Vue.component('v-base-layout', BaseLayout);

export default ({ app, store }, inject) => {
  inject('core', {
    getDefaultLocale() {
      // replace to fix Safari that returns locale in lowercase
      return window.navigator.language.replace(/^([a-z]{2})-([a-z]{2})$/, (_match, $1, $2) => {
        return `${$1}-${$2.toUpperCase()}`;
      });
    },
    hasSafeaPermission(aliasPermission) {
      return hasSafeaPermission(aliasPermission, store);
    }
  });

  if (!Vue.layout_v2) {
    Vue.layout_v2 = true;

    // TODO: After everyone makes use of the correct version of the layout, this can be removed
    Vue.mixin({
      beforeCreate() {
        // Adds a global mixin checking whether to use the new layout
        if (store.state._core.application.prepareLayoutv2) {
          if (store.state._core.application.layoutv2) {
            return;
          }
          store.commit('_core/application/SET_LAYOUT_V2', true);
        } else {
          if (!store.state._core.application.layoutv2) {
            return;
          }
          store.commit('_core/application/SET_LAYOUT_V2', false);
        }
      }
    });
  }
};
